import { Controller } from "@hotwired/stimulus"

declare global {
  interface Window {
    adsbygoogle?: object[]
  }
}

// Queues this AdSense unit for fill; Google's script processes the queue and
// stamps data-ad-status / data-adsbygoogle-status on the element.
export default class extends Controller<HTMLElement> {
  connect() {
    if (this.element.dataset.adsbygoogleStatus) return
    // A unit hidden at this breakpoint has no width, and Google's script throws on a responsive unit it can't size.
    if (this.element.offsetWidth === 0) return
    // The AdSense script only knows the URL it initialized on — under Turbo
    // that's the visitor's entry page. Stamping the current URL here keeps
    // attribution correct on any render path, incl. Turbo Stream fragments
    // whose server-side request URL is the stream endpoint, not the page.
    this.element.dataset.pageUrl = window.location.href
    ;(window.adsbygoogle = window.adsbygoogle ?? []).push({})
  }
}
